import { Component } from '@angular/core';

@Component({
  selector: 'app-support-request-button',
  templateUrl: './support-request-btn.component.html',
  styleUrls: ['./support-request-btn.component.scss'],
})
export class SupportRequestBtnComponent {}
